import { SvgIcon } from '@mui/material';
import React from 'react';

export default function StackChartIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 44 44" style={{ width: `22px`, height: `22px`, color: `#1D1D1B`, ...props.style }}>
      <g>
        <path d="M22.03,25.45c-.35,0-.71-.09-1.03-.28L3.44,14.9c-.62-.36-1.01-1.04-1.01-1.76,0-.72,.39-1.4,1.02-1.76L21.01,1.22c.63-.36,1.41-.36,2.04,0l17.51,10.13c.62,.36,1.01,1.03,1.02,1.76s-.38,1.4-1.01,1.76l-17.51,10.29c-.32,.19-.68,.28-1.03,.28ZM6.38,13.15l15.64,9.14,15.6-9.17L22.03,4.1,6.38,13.15Z" />
        <path d="M22.03,34.21c-.36,0-.71-.09-1.03-.28L3.17,23.52c-.72-.42-.96-1.34-.54-2.05,.42-.72,1.34-.96,2.05-.54l17.34,10.13,17.29-10.13c.71-.42,1.63-.18,2.05,.54,.42,.71,.18,1.63-.54,2.05l-17.77,10.41c-.32,.19-.67,.28-1.03,.28Zm-.49-2.87h0Z" />
        <path d="M22.03,43.05c-.36,0-.71-.09-1.03-.28L3.17,32.36c-.72-.42-.96-1.34-.54-2.05,.42-.72,1.34-.96,2.05-.54l17.34,10.13,17.29-10.13c.71-.42,1.63-.18,2.05,.54,.42,.71,.18,1.63-.54,2.05l-17.77,10.41c-.32,.19-.67,.28-1.03,.28Zm-.49-2.87h0Z" />
      </g>
    </SvgIcon>
  );
}
